import {Component, HostListener, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {AccordionModule} from "primeng/accordion";
import {FormsModule} from "@angular/forms";
import {Router} from "@angular/router";
import {GlobalService} from "../../../services/global.service";
import {KeyValuePipe, NgForOf, NgIf} from "@angular/common";
import {locale} from "moment";
import {Config, ConfigService} from "../../../services/config.service";

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [
        AccordionModule,
        FormsModule,
        NgForOf,
        KeyValuePipe,
        NgIf
    ],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit {

    footer: [{'links':[]}];
    bottom_bar: any;
    copyright: any;
    socialNetwork: [];
    language: string = "fa";
    footerText: string;

    protected readonly document = document;

    constructor(public route: Router,
                public global: GlobalService,
                @Inject(LOCALE_ID) public locale: string,
                public conf: ConfigService) {

    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (document.body.offsetWidth < 550) {
            this.footerText = this.bottom_bar != null ? (this.bottom_bar['text'] + '').substring(0, 250) + ((this.bottom_bar['text'] + '').length > 255 ? "..." : "") : '';
            this.moreStatus = false;
        } else {
            this.footerText = this.bottom_bar != null ? (this.bottom_bar['text'] + '') : '';
            this.moreStatus = true;
        }
    }

    ngOnInit(): void {
        this.language = this.locale;
        if (this.global.getMainData()['main-page'] != null) {
            this.footer = JSON.parse(this.global.getMainData()['main-page']['data'])['footer'];
            this.bottom_bar = JSON.parse(this.global.getMainData()['main-page']['data'])['bottom-bar'];
            this.copyright = JSON.parse(this.global.getMainData()['main-page']['data'])['copyright'];
            this.socialNetwork = JSON.parse(this.global.getMainData()['main-page']['data'])['social-networks'];

            setTimeout(() => {
                this.footer = JSON.parse(this.global.getMainData()['main-page']['data'])['footer'];
                this.bottom_bar = JSON.parse(this.global.getMainData()['main-page']['data'])['bottom-bar'];
                this.copyright = JSON.parse(this.global.getMainData()['main-page']['data'])['copyright'];
                this.socialNetwork = JSON.parse(this.global.getMainData()['main-page']['data'])['social-networks'];
            }, 1000)
        }
        this.footerMoreClick();

    }


    changLanguage() {
        let loc = window.location.pathname.split('/')[1];
        this.route.navigate(['/']);
        setTimeout(() => {
            if (loc.length > 1)
                window.location.href = window.location.href.replace("/" + loc + "/", "/" + this.language + "/");
        }, 200);

    }


    moreStatus: boolean = true;

    footerMoreClick() {
        if (document.body.offsetWidth < 550) {
            if (this.moreStatus) {
                this.footerText = this.bottom_bar != null ? (this.bottom_bar['text'] + '').substring(0, 250) + "..." : '';
            } else {
                this.footerText = this.bottom_bar != null ? (this.bottom_bar['text'] + '') : '';
            }
            this.moreStatus = !this.moreStatus;
        } else {
            this.footerText = this.bottom_bar != null ? (this.bottom_bar['text'] + '') : '';
        }
    }




}
